import { FC, useEffect } from 'react';
import { createUseStyles } from 'react-jss';
import { mediaMinWidth } from '../theme/utils';
import { CareMapFlow } from './CareMapFlow';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { CareMapState } from './CareMapState';
import { isPlatform } from '@ionic/react';
import { CareMapDrawerState } from './CareMapDrawerState';
import { useSubscription } from '@meraki-internal/state';
import { InnerhivePage } from '../InnerhivePage';
import { MixPanelEventEmitter } from '../metrics/MixPanelEventEmitter';
import { CareMapConfigPopover } from './CareMapConfigPopover';
import { CareTabsProvider } from '../care/CareTabsProvider';
import { CareRecipientSwitcher } from '../navigation/CareRecipientSwitcher';


const useStyles = createUseStyles({
    switcher: {
        top: 20,
        left: 20,
        zIndex: 5,
        width: '100%',
        position: 'absolute',

        [mediaMinWidth.lg]: {
            left: 150
        }
    }
});

export const CareMapPage: FC = () => {
    const classes = useStyles();

    const careMapStateInstance = useInstance(CareMapState);
    useSubscription(() => careMapStateInstance);
    const drawerState = useInstance(CareMapDrawerState);
    useSubscription(() => drawerState);
    const mixpanel = useInstance(MixPanelEventEmitter);
    const tabsProvider = useInstance(CareTabsProvider);

    const isDrawerOpen = drawerState.isOpen();

    useEffect(() => {
        mixpanel.track('Care Map Page Opened');
    }, [mixpanel]);

    const careMap = careMapStateInstance.getActiveCaremap();

    if (!careMap) {
        return null;
    }

    return (
        <InnerhivePage title="Care" skipAddingIonContent skipAddingNavigation tabs={tabsProvider.getTabs()}>
            <div className={classes.switcher}>
                <CareRecipientSwitcher />
            </div>

            <CareMapFlow
                name="full"
                blur={isDrawerOpen}
                fit={isDrawerOpen ? 'none' : 'custom'}
                includeControls={isPlatform('desktop')}
                careMap={careMap}
            />

            <CareMapConfigPopover />

        </InnerhivePage>
    );
};
